import { render } from "./CadastroDeTrechos.vue?vue&type=template&id=0a5d43d1"
import script from "./CadastroDeTrechos.vue?vue&type=script&lang=js"
export * from "./CadastroDeTrechos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bhfagundes/Desktop/mobs2/operacoes-front-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__